import { IIntakeIdWithDates } from 'api-paths-cas';
import { all, call, cancelled, fork, put, select, takeLatest, getContext } from 'redux-saga/effects';
import { getUniqueCount } from '../../../api/api';
import isTesting from '../../../utilities/isTesting';
import { logout } from '../../auth/actions';
import { AuthState } from '../../auth/types';
import { getAuth, getConfig, getIntakeId, getIntakeRange, getUI } from '../../selectors';
import { getSelectedTagsFailure, getSelectedTagsSuccess, getSelectedTagsComplete } from '../actions';
import { DashboardActionTypes } from '../types';
import { createUniqueCountParams } from './helpers';

export let getSelectedTagsAbortController: AbortController;

export function* handleGetSelectedTagsTotals(): any {
  let res: any;
  const auth: AuthState = yield select(getAuth);
  const config = yield select(getConfig);
  const intakeId: string = yield select(getIntakeId);
  if (!intakeId && !isTesting) {
    return;
  }
  const { headerTab } = yield select(getUI);
  const intakeRange: IIntakeIdWithDates | undefined = yield select(getIntakeRange, intakeId!);
  const context = yield getContext('sagaContext');
  const idToken: any = yield call(context.getIdToken);

  try {
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetSelectedTagsTotals');
      return;
    }
    const getSelectedTagsParams = createUniqueCountParams({
      getUniqueCountAbortController: getSelectedTagsAbortController,
      auth,
      config,
      intakeId,
      headerTab,
      intakeRange,
      idToken,
    });
    if (!getSelectedTagsParams) {
      return;
    }

    getSelectedTagsAbortController = new AbortController();
    const tagsRes = yield call(getUniqueCount, 'tags', getSelectedTagsParams);
    const pTagsRes = yield call(getUniqueCount, 'programmatic_tags', getSelectedTagsParams);
    res = { ...tagsRes, ...pTagsRes };
  } catch (err) {
    yield put(getSelectedTagsFailure(err));
    return;
  } finally {
    if (yield cancelled()) {
      // the task was cancelled
      getSelectedTagsAbortController.abort();
      return;
    }
  }
  yield put(getSelectedTagsSuccess(res));

  yield put(getSelectedTagsComplete());
}

function* watchGetSelectedTags() {
  yield takeLatest(DashboardActionTypes.GET_SELECTED_TAGS, handleGetSelectedTagsTotals);
}

function* GetSelectedTagsSaga() {
  yield all([fork(watchGetSelectedTags)]);
}

export default GetSelectedTagsSaga;
